import { render, staticRenderFns } from "./ExcluirAtivo.vue?vue&type=template&id=df980e70&scoped=true&"
import script from "./ExcluirAtivo.vue?vue&type=script&lang=js&"
export * from "./ExcluirAtivo.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirAtivo.vue?vue&type=style&index=0&id=df980e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df980e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VForm,VImg,VRow,VSelect})
